import React from 'react';
import { Box } from '@chakra-ui/react';
import {
  HStack,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Button } from 'components/ui/button';
import { UserBlock } from '../../../models/block';

type Props = {
  block: UserBlock;
  instructions: string;
  onInstructionsChange: (text: string) => void;
  handleUpdateUserBlock: () => void;
};

export const BlockEditContent = ({
  block,
  instructions,
  onInstructionsChange,
  handleUpdateUserBlock,
}: Props) => {
  const instructionsEditable = true;

  return (
    <VStack h={'100%'}>
      <HStack
        alignItems={'flex-start'}
        borderBottomWidth={1}
        borderColor={'cloud.200'}
        pb={4}
      >
        <VStack flex={1} pr={3}>
          <Text color={'secondary.500'} fontSize={'xl'} fontWeight={'medium'}>
            {block.block_name}
          </Text>
        </VStack>
      </HStack>

      <HStack alignItems={'center'} justifyContent={'space-between'} mt={5}>
        <Text color={'secondary.500'} fontSize={'lg'} fontWeight={'medium'}>
          Instructions
        </Text>
        <Text color={'blueGray.600'} fontSize={'xs'}>
          {instructions.length}/500
        </Text>
      </HStack>

      <Box
        mt={2}
        borderWidth={1}
        borderColor={'cloud.200'}
        borderRadius={'md'}
        overflow={'hidden'}
      >
        <textarea
          disabled={!instructionsEditable}
          maxLength={500}
          onChange={(e) => onInstructionsChange(e.target.value)}
          placeholder={'Add patient instructions...'}
          style={{
            border: 0,
            color: '#2D6670',
            fontFamily: 'var(--chakra-fonts-body)',
            fontSize: 'var(--chakra-font-sizes-sm)',
            height: '120px',
            outline: 'none',
            padding: '12px',
            resize: 'none',
            width: '100%',
          }}
          value={instructions}
        />
      </Box>

      <HStack
        justifyContent={'flex-start'}
        borderTopWidth={1}
        borderColor={'cloud.200'}
        pt={4}
        gap={3}
        mt={'auto'}
      >
        <Button
          disabled={!instructionsEditable}
          backgroundColor={'secondary.500'}
          flex={1}
          maxW={'1/2'}
          onClick={handleUpdateUserBlock}
        >
          <Text color={'white'} fontSize={'md'} fontWeight={'normal'}>
            Update
          </Text>
        </Button>
      </HStack>
    </VStack>
  );
};
